module.exports = __webpack_public_path__ + "img/HumanBody.6924542f.svg";